import React, { Component } from 'react';
import './Navigation.css';
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";

class Navigation extends Component {
    render() {
        return (
            <HashRouter>
                <div>
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <NavLink to="/envelope" className="nav-item nav-link">Envelope</NavLink>
                            <NavLink to="/calendar" className="nav-item nav-link">Calendar</NavLink>
                            <NavLink to="/hvac" className="nav-item nav-link">HVAC</NavLink>
                            <NavLink to="/lighting" className="nav-item nav-link">Lighting</NavLink>
                        </div>
                    </nav>
                </div>
            </HashRouter>
        );
    }
}

export default Navigation;




// WEBPACK FOOTER //
// ./src/components/Navigation.js